import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";
import { api } from "../lib/api";

export default function Local() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.attractions().then(d => setItems(d.items || [])); }, []);

    return (
        <>
            <SEO title="Local Clinton, MO: Truman Lake & Henry County Guide" description="Your local guide to Clinton, Missouri — Truman Lake, the historic square, Katy Trail, Henry County Museum, and more. From Liquor Studio." path="/local/clinton-mo" />

            <section style={{ paddingTop: 140, paddingBottom: 48, borderBottom: "1px solid var(--ls-border)" }}>
                <div className="ls-container">
                    <span className="eyebrow">Local Clinton, MO</span>
                    <h1 className="font-display mt-4 text-white" style={{ fontSize: "clamp(40px, 6vw, 72px)", fontWeight: 500, lineHeight: 1.02, letterSpacing: "-0.02em" }}>
                        Things to do <em style={{ fontStyle: "italic", color: "var(--ls-gold)", fontWeight: 400 }}>nearby</em>
                    </h1>
                    <p className="mt-5" style={{ color: "var(--ls-text-secondary)", fontSize: 17, lineHeight: 1.6, maxWidth: 700 }}>
                        Clinton is the hub of west-central Missouri — Truman Lake, the historic square,
                        the Katy Trail's western terminus, and miles of country drives. Here's the local guide.
                    </p>
                </div>
            </section>

            <section className="py-12">
                <div className="ls-container">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-testid="attractions-grid">
                        {items.map(a => (
                            <Link key={a.slug} to={`/local/${a.slug}`} className="cat-card block" data-testid={`attraction-card-${a.slug}`}>
                                <div style={{ aspectRatio: "16/10", overflow: "hidden" }}>
                                    <img src={a.cover_image_url} alt={a.name} loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                </div>
                                <div className="p-7">
                                    <div className="flex items-center gap-2 text-xs uppercase tracking-wider" style={{ color: "var(--ls-gold)" }}>
                                        <MapPin size={12} /> {a.distance_from_store}
                                    </div>
                                    <h2 className="font-display text-white mt-3" style={{ fontSize: 26, fontWeight: 500, lineHeight: 1.15 }}>{a.name}</h2>
                                    <p className="mt-3" style={{ color: "var(--ls-text-secondary)", fontSize: 15, lineHeight: 1.6 }}>{a.short_description}</p>
                                    {a.visitor_count_annual && <p className="mt-3 text-xs" style={{ color: "var(--ls-text-muted)" }}>{a.visitor_count_annual}</p>}
                                    <span className="inline-flex items-center gap-2 mt-4 text-sm font-medium" style={{ color: "var(--ls-gold)" }}>Visit guide <ArrowRight size={14} /></span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
